import { isAxiosError } from "axios"

export const GENERIC_ERROR_MESSAGE = "Something Went Wrong, Please Try Again"

type TErrorBody = {
  message?: unknown
  error?: unknown
  error_message?: unknown
}

// Garcon reports failures as { message } (halts), { error, type } (GarconError),
// { error_message } or a plain string. Anything else returns undefined so that an
// object is never interpolated into the message the user ends up reading.
const getErrorDetail = (data: unknown): string | undefined => {
  if (typeof data === "string") return data || undefined
  if (!data || typeof data !== "object") return undefined

  const { message, error, error_message: errorMessage } = data as TErrorBody

  return [message, error, errorMessage].find(
    (value): value is string => typeof value === "string" && value.length > 0,
  )
}

// Turns a rejected request into the message shown to the user: the detail sent by
// the backend when there is one, and the axios message plus a generic explanation
// when there is not.
export const getApiErrorMessage = (error: unknown): string => {
  // Interceptors registered earlier in the chain already reject with a string.
  if (typeof error === "string") return error

  const detail = isAxiosError(error)
    ? getErrorDetail(error.response?.data)
    : undefined

  if (detail) return detail

  const prefix = error instanceof Error ? error.message : String(error)

  return `${prefix}: ${GENERIC_ERROR_MESSAGE}`
}
